import styles from "./Contact.module.scss"

import Section from "components/Section"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import axios from "axios"

import validationSchema from "./validationSchema"
import TextField from "../fields/Text"
import Checkbox from "../fields/Checkbox"
import Button from "../../Button"
import TextareaField from "../fields/Textarea"
import FIELDS from "./fields"
import { useState } from "react"
import getConfig from "next/config"
import StatusBox from "../StatusBox"

const DEBUG = false

const {
  publicRuntimeConfig: { API_URL },
} = getConfig()

const ContactForm = ({ data }) => {
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [submitError, setSubmitError] = useState(false)

  const {
    section_teaser,
    section_headline,
    section_subline,
    section_text,
    section_links,
  } = data

  const methods = useForm({
    defaultValues: DEBUG
      ? {
          name: "Max Mustermann",
          email: "Max.Mustermann@example.com",
          phone: "12456789",
          message_text:
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, [...]",
          consent: "yes",
        }
      : {
          name: null,
          email: null,
          phone: null,
          message_text: null,
          consent: null,
        },
    resolver: zodResolver(validationSchema),
  })

  const {
    watch,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = methods

  const onSubmit = async (data) => {
    setSubmitError(false)
    setLoading(true)
    setSubmitted(true)

    try {
      const response = await axios.post(`${API_URL}/!/forms/contact`, data)

      if (response.status !== 200) {
        setSubmitError(true)
      }

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
      setSubmitError(true)
    }
  }

  const consented = watch("consent")

  return (
    <Section
      teaser={section_teaser}
      headline={section_headline}
      subline={section_subline}
      text={section_text}
      links={section_links}
    >
      {submitted && (
        <StatusBox
          status={submitError ? "error" : "success"}
          className="container mb-16"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setSubmitError(false)
            setSubmitted(false)
            reset()
          }}
        />
      )}

      <form className={styles.contactForm} onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.inner}>
          <div className={styles.left}>
            <TextField
              methods={methods}
              field={FIELDS[0]}
              error={!!errors.name}
              inputClassName={styles.input}
            />
            <TextField
              methods={methods}
              field={FIELDS[1]}
              error={!!errors.email}
              inputClassName={styles.input}
            />
            <TextField
              methods={methods}
              field={FIELDS[2]}
              error={!!errors.phone}
              inputClassName={styles.input}
            />
          </div>
          <div className={styles.right}>
            <TextareaField
              methods={methods}
              field={FIELDS[3]}
              error={!!errors.message_text}
              inputClassName={styles.input}
            />
          </div>
        </div>

        <Checkbox
          methods={methods}
          field={FIELDS[4]}
          inputClassName={styles.input}
        />

        <Button
          className="mt-6 self-end"
          type="submit"
          displayType={{ value: "button_primary" }}
          disabled={!consented}
          loading={loading}
        >
          Absenden
        </Button>
      </form>
    </Section>
  )
}

export default ContactForm
